import { FileUploadSimple } from './FileUploadSimple'

export default FileUploadSimple
